export const INVOICE_STATUS = {
  OPEN: 'OPEN',
  CLOSED: 'CLOSED',
};
